import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { RequestEditorComponent } from '../request-editor.component';

export const requestEditorCanDeactivate = async (
    component: RequestEditorComponent,
    _: ActivatedRouteSnapshot,
    { url }: RouterStateSnapshot
): Promise<boolean> => {
    return component.canDeactivate(url);
};
